import type { z } from 'zod'
export const customErrorMap: z.core.$ZodErrorMap = issue => {
  if (issue.code === 'too_small') {
    return { message: `${issue.minimum}以上の文字数で入力してください。` }
  }
  // undefined を返すと zod の既定メッセージが使われる
  return undefined
}
